import React, { useCallback, useContext, useState } from 'react';
import { httpPost, getRequestId, httpGet } from '@qxwz/http-client';
import cookie from 'react-cookies';
import { AppName, sessionRequestId } from 'constant/app';

interface IResourceItemContext {
    getResUnitName: Function;
}

const ResourceItemContext = React.createContext<IResourceItemContext>({} as IResourceItemContext);
const ResourceItemContextProvider = ({ children }: { children: any }) => {
    const initalResourceUnitMap = localStorage.getItem('resourceUnitMap')
        ? JSON.parse(localStorage.getItem('resourceUnitMap') as string)
        : '';
    const [resourceUnitMap, setResourceUnitMap] = useState(initalResourceUnitMap);
    const findResourceItem = () => {
        httpPost(
            '/bffportal/proxy/noah-biz-api/rest/resource-item/queryByPricingType',
            {
                caller: AppName,
                requestId: getRequestId(),
                sessionRequestId,
                param: { onlyUnitFlag: true },
            },
            {
                headers: {
                    'csrf-token': cookie.load('_csrf_token'),
                },
            },
        ).then((res: any) => {
            setResourceUnitMap(res.resourceUnitMap);
            localStorage.setItem('resourceUnitMap', JSON.stringify(res.resourceUnitMap));
        });
    };
    React.useEffect(() => {
        if (!cookie.load('_csrf_token')) {
            httpGet('/bffportal/proxy/rest/internal/sso/v1/license/detect.rpc?channel=').finally(() => {
                findResourceItem();
            });
        } else {
            findResourceItem();
        }
    }, []);

    const getResUnitName = useCallback(
        (recourceItemCode: string) => {
            return resourceUnitMap && resourceUnitMap[recourceItemCode];
        },
        [resourceUnitMap],
    );

    return (
        <ResourceItemContext.Provider
            value={{
                getResUnitName,
            }}
        >
            {children}
        </ResourceItemContext.Provider>
    );
};

const useResourceItemContext = () => useContext(ResourceItemContext);

export { ResourceItemContext, useResourceItemContext, ResourceItemContextProvider };
